import React from 'react';
import { RouteObject } from 'react-router-dom';
import SidebarLayout from '../../Layout/SidebarLayout';
import adminRoutes from '../AdminSettings/AdminSettings';
import personalRoutes from '../PersonalSettings/PersonalSettings';
import SettingsNav from './SettingsNav';

const settingsRoutes: RouteObject[] = [
  {
    element: (
      <SidebarLayout>
        <SettingsNav />
      </SidebarLayout>
    ),
    children: [...adminRoutes, ...personalRoutes],
  },
];

export default settingsRoutes;
